import { Injectable, signal, Signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidenavContentLifecycleService {
    private readonly _isLoaded = signal<boolean>(false);

    readonly isLoaded: Signal<boolean> = this._isLoaded.asReadonly();

    setLoaded(state: boolean): void {
        this._isLoaded.set(state);
    }
}
